<template>
  <div
    class="temp-img preload-wrap temp-img-preview"
    :class="{ loaded: imageIsLoaded }"
  >   
      <div v-if="loading" class="spinner-border-container" >
        <div class="spinner-border text-secondary" role="status"><span class="sr-only">Uploading...</span></div>
      </div>
      <div v-if="error">
        {{error}}
      </div>
      <FancyBoxComponent
      v-else-if="imageIsLoaded"
          :options="{
            Carousel: {
              infinite: false
            }
          }"
        >
        <div
        data-fancybox="gallery"
        :src="dataUrl"
        :style="photoStyles"
        class="photo-preview__blur-container"
        :class="{ 'no-blur': !loading }"
      >
    <img :src="dataUrl" class="fancybox-img" />
    </div>
        </FancyBoxComponent>
      
  </div>

</template>
<script>
import { readAsDataURL } from '@/utils/AsyncFileReader'
import FancyBoxComponent from '@/components/FancyBoxComponent.vue'

export default {
    name: 'VPhotoPreview',
    props: {
        image: {
            required: true,
        },
        loading: {
            type: Boolean,
            default: false
        },
        mainImage: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
        }
    },
    data: () => ({
        dataUrl: '',
        error: '',
        imageIsLoaded: false
    }),
    computed: {
        photoStyles() {
            return `background-image: url(${this.dataUrl});`;
        }
    },
    async created() {
        try {
            this.dataUrl = this.type === 'url' ? this.image : await readAsDataURL(this.image);
        }
        catch (error) {
            error = 'Error';
        }
        finally {
            this.imageIsLoaded = true;
        }
    },
    components: { FancyBoxComponent }
}
</script>
<style>
.spinner-border-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
}

.photo-preview__blur-container {
  z-index: 2;
  filter: blur(3px);
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  border-radius: 16px;
}

.photo-preview__blur-container.no-blur {
  filter: unset;
}
.fancybox-img{
  height: 100%;
    width: 100%;
    border-radius: 16px;
}
</style>